import {connect} from "react-redux";
import {Error404} from "./view";

const Error404Container=connect()(Error404);
export default Error404Container;